import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import SectionHeader from "../common/SectionHeader";
import StatCounter from "@/components/common/StatCounter";
import RevealOnScroll from "@/components/common/RevealOnScroll";

// --------------------------------------------------------------------------------

type IMetricsDataCardType = {
  number?: string;
  name?: string;
};

type ISuccessMetricsProps = HTMLAttributes<HTMLDivElement> & {
  heading?: string;
  description?: ReactNode;
  successMetricsData?: IMetricsDataCardType[];
};

const SuccessMetrics: FC<ISuccessMetricsProps> = ({
  heading,
  description,
  successMetricsData,
  className,
}) => {
  return (
    <section className={clsx("container py-14 md:py-20 xl:py-24", className)}>
      {(heading || description) && (
        <RevealOnScroll>
          <SectionHeader
            title={heading}
            subtitle={description}
            align="left"
            className="mb-10 md:mb-14"
          />
        </RevealOnScroll>
      )}

      {successMetricsData && successMetricsData.length > 0 && (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:gap-6">
          {successMetricsData.map((card, idx) => (
            <RevealOnScroll key={idx} index={idx} className="h-full">
              <div className="flex h-full flex-col items-center justify-center gap-2 rounded-2xl p-6 text-center transition-all duration-300 odd:bg-primary-50 even:bg-primary-100 hover:-translate-y-1 hover:shadow-md lg:p-8">
                <StatCounter
                  value={card.number ?? ""}
                  className="block bg-primary-gradient bg-clip-text font-bricolage-grotesque text-[clamp(2rem,6vw+0.5rem,3.5rem)] font-semibold text-transparent"
                />
                <p className="text-sm font-normal text-black-700 lg:text-base">
                  {card.name}
                </p>
              </div>
            </RevealOnScroll>
          ))}
        </div>
      )}
    </section>
  );
};

export default SuccessMetrics;
